import { render, staticRenderFns } from "./Graph.vue?vue&type=template&id=2df2c317&"
import script from "./Graph.vue?vue&type=script&lang=js&"
export * from "./Graph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df2c317')) {
      api.createRecord('2df2c317', component.options)
    } else {
      api.reload('2df2c317', component.options)
    }
    module.hot.accept("./Graph.vue?vue&type=template&id=2df2c317&", function () {
      api.rerender('2df2c317', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/graph/Graph.vue"
export default component.exports